
export const MASTER_FIELDS = [

]


export const MEDIA_FIELDS = [

    { key: 'name', label: "Name" },
    { key: 'price', label: "Price" },

]




const FIELDS = [
    ...MEDIA_FIELDS,
    ...MASTER_FIELDS
]

export default FIELDS


